import {SET_RESUME_DATA} from '../actions/resume';

const initialState = {
  overWrite: false
};

function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_RESUME_DATA:
      if(action.data.overWrite) {
        return { ...action.data }
      }
      return {...state, ...action.data};
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/resume.js